import React, { useEffect } from "react";
import { Navbar } from "./header";
import { Footer } from "./footer";
import "./OurStory.css";

export const About = () => {
  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll('.fade-in-section');
      elements.forEach(element => {
        const elementTop = element.getBoundingClientRect().top;
        const elementBottom = element.getBoundingClientRect().bottom;
        const isVisible = (elementTop < window.innerHeight - 100) && (elementBottom > 0);
        if (isVisible) {
          element.classList.add('is-visible');
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen luxury-background">
      <Navbar />
      
      {/* Hero Section */}
      <div className="hero-section ourstory-hero-section fade-in-section">
        <h1 className="hero-title">Our Story</h1>
        <div className="hero-line"></div>
        <p className="hero-subtitle">Where Artistry Meets Emotion in Every Frame</p>
      </div>

      <section className="story-section">
        {/* Vision Section */}
        <div className="content-container fade-in-section">
          <div className="image-wrapper">
            <img
              src="/resources/images/our-story1.jpg"
              alt="Artistic wedding photography"
              className="luxury-image"
            />
            <div className="image-overlay"></div>
          </div>
          <div className="text-content">
            <h2 className="section-title">The Vision</h2>
            <div className="text-wrapper">
              <p className="elegant-text">
                At <span className="brand-name">Stories by Kalakaar</span>, we believe that every moment 
                holds a story waiting to be told. Our journey began with a vision to transform photography 
                from mere documentation into an art form that captures the soul of each celebration.
              </p>
              <p className="elegant-text">
                We see beauty in the delicate interplay of light and shadow, in the genuine emotions that 
                unfold naturally, and in the quiet moments that speak volumes. This vision guides every 
                frame we capture.
              </p>
            </div>
          </div>
        </div>

        {/* Artistry Section */}
        <div className="content-container reverse fade-in-section">
          <div className="image-wrapper">
            <img
              src="/resources/images/our-story2.jpg"
              alt="Artistic photography process"
              className="luxury-image"
            />
            <div className="image-overlay"></div>
          </div>
          <div className="text-content">
            <h2 className="section-title">Our Artistry</h2>
            <div className="text-wrapper">
              <p className="elegant-text">
                Each photograph we create is a careful composition where technical expertise meets artistic 
                intuition. We blend contemporary techniques with timeless aesthetics to craft images that 
                will be cherished for generations.
              </p>
              <p className="elegant-text">
                Our approach is rooted in the belief that true luxury lies in authenticity. We capture 
                real moments with an editorial eye, ensuring each image is both genuine and masterfully crafted.
              </p>
            </div>
          </div>
        </div>

        {/* Quote Section */}
        <div className="quote-section fade-in-section">
          <div className="quote-container">
            <div className="quote-mark">"</div>
            <blockquote className="luxury-quote">
              Every moment tells a story,<br/>
              every frame captures an emotion,<br/>
              every photograph becomes a legacy.
            </blockquote>
          </div>
        </div>

        {/* Philosophy Section */}
        <div className="content-container fade-in-section">
          <div className="image-wrapper">
            <img
              src="/resources/images/our-story3.jpg"
              alt="Candid moment capture"
              className="luxury-image"
            />
            <div className="image-overlay"></div>
          </div>
          <div className="text-content">
            <h2 className="section-title">Our Philosophy</h2>
            <div className="text-wrapper">
              <p className="elegant-text">
                We believe in the power of subtle moments — a gentle touch, a knowing glance, 
                tears of joy. These fleeting instances become timeless treasures through our lens, 
                telling stories that words alone cannot express.
              </p>
              <p className="elegant-text">
                Our philosophy is grounded in the art of observation and the patience to wait for 
                those perfect moments when emotion, light, and composition align to create something 
                extraordinary.
              </p>
            </div>
          </div>
        </div>

        {/* Closing Section */}
        <div className="closing-section fade-in-section">
          <p className="closing-text">
            From intimate celebrations to grand occasions, we approach each event with the same level 
            of dedication and artistic vision. Our commitment is to create not just photographs, but 
            lasting legacies that tell your unique story for generations to come.
          </p>
          <div className="signature-line"></div>
          <p className="signature-text">Stories by Kalakaar</p>
        </div>
      </section>

      {/* Founder Section - Separate from story-section */}
      <section className="founder-container">
        <div className="founder-section">
          <div className="founder-content fade-in-section">
            <div className="founder-image-wrapper">
              <img
                src="/resources/images/founder.jpg"
                alt="Shresth Gupta - Founder of Stories by Kalakaar"
                className="founder-image"
              />
            </div>
            <div className="founder-text">
              <h2 className="section-title">Meet Our Founder</h2>
              <div className="text-wrapper">
                <p className="elegant-text">
                  Shresth Gupta, the visionary founder of Stories by Kalakaar, brings a unique blend of 
                  artistic sensibility and technical expertise to every project. His journey in photography 
                  began with a simple passion for capturing moments, which evolved into a deep understanding 
                  of how images can preserve the essence of life's most precious occasions.
                </p>
                <p className="elegant-text">
                  With years of experience in wedding and event photography, Shresth has developed a 
                  distinctive style that combines candid storytelling with artistic composition. His work 
                  is characterized by an ability to capture authentic emotions while maintaining the 
                  highest standards of professional photography.
                </p>
                <p className="elegant-text">
                  Under his leadership, Stories by Kalakaar has grown into a trusted name in the industry, 
                  known for creating timeless memories that families cherish for generations. Shresth's 
                  commitment to excellence and personal attention to each client's vision continues to be 
                  the driving force behind our success.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};
